/** 
 * @Desc: 添加 学习资源
 */ 
<template>
  <!-- :title="learningTitle ? '“ ' + learningTitle + ' ” 预览' : '预览'" -->
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="1200px"
    :append-to-body="true"
    :close-on-click-modal="true"
    :before-close="_dialogClose"
    class="learn-task-preview-component"
    :class="previewType === 3 || previewType === 4 ? 'show-footer' : ''"
    custom-class="self-el-dialog"
  >
    <i v-if="previewType === 6 && learningData && learningData.isExcellent" class="iconfont iconyouxiu"></i>
    <!-- 分配学习任务内容基本信息 -->
    <div
      class="learn-task-module preview-learn-student-info"
      v-if="!loading && learningData && (previewType === 2 || previewType === 5)"
      >
      <span class="span-icon span1">
        <i class="iconfont iconlaoshi"></i>{{taskBaseInfo.authorName}}
      </span>
      <span class="span-icon span2">
        <i class="iconfont iconkechengzhongxin"></i>
        {{infoObj.subjectName}}
      </span>
      <span
        class="span-icon span3 no-wrap"
        :title="taskBaseInfo.classOrGroupName.length > 25 ? taskBaseInfo.classOrGroupName : ''"
      >
        <i class="iconfont iconxiaozu"></i>
        {{taskBaseInfo.classOrGroupName}}
      </span>
      <span class="span-icon span4">
        <i class="iconfont iconkaishijieshushijian"></i>
        {{taskBaseInfo.startTime}} 至 {{taskBaseInfo.dueTime}}
      </span>
      <span class="span-icon span5">
        <i class="iconfont"
          :class="{
            'iconfont': true,
            'iconjinhangzhong': taskBaseInfo.status === 1,
            'iconweikaishi1': taskBaseInfo.status === 2,
            'iconguoqi': taskBaseInfo.status === 3,
          }"
          ></i>
        {{taskBaseInfo.status === 1 ? '进行中' : (taskBaseInfo.status === 2 ? '未开始': '已过期')}}
      </span>
      <span v-if="false" class="span-icon span6 task-progress">
        <el-progress
          type="circle"
          :percentage="taskBaseInfo.totalStudentCount ? (taskBaseInfo.completedStudentCount / taskBaseInfo.totalStudentCount) * 100 : 0"
          :stroke-width="2"
          :width="20"
          :show-text="false"
          color="#007A49"
        ></el-progress>
        <span>{{taskBaseInfo.completedStudentCount}} / {{taskBaseInfo.totalStudentCount}}</span>
      </span>
    </div>
    <!-- 分配学习任务学生基本信息 -->
    <div
      class="learn-task-module preview-learn-student-info"
      v-else-if="!loading && learningData && (previewType === 3 || previewType === 4 || previewType === 6)"
      >
      <span class="span-icon span1">
        <i class="iconfont iconlaoshi"></i>
        {{learningData.studentName}}
      </span>
      <span class="span-icon span2">
        <i class="iconfont iconkechengzhongxin"></i>
        {{learningData.subjectName}}
      </span>
      <span class="span-icon span3">
        <i class="iconfont iconxiaozu"></i>
        {{learningData.classOrGroupName}}
      </span>
      <span class="span-icon span4">
        <i class="iconfont iconkaishijieshushijian"></i>
        {{learningData.startTime}} 至 {{learningData.stopTime}}
      </span>
      <span class="span-icon span5">
        <i class="iconfont iconhaoshi"></i>
        {{learningData.estimated}}
      </span>
      <span class="span-icon span6 pie-ercentage" v-if="learningData.options">
        <PiePercentage :options="learningData.options" />
        {{learningData.objectiveCorrectedNum}} / {{learningData.objectiveTotal}}
      </span>
    </div>
    <div
      v-if="loading || !learningData"
      class="learn-task-preview learn-task-preview-laoding"
      v-loading="loading"
      element-loading-text="数据正在跑步前进中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="grba(255, 255, 255, 0.5)"
    ></div>
    <div class="learn-task-preview" v-else>
      <!-- 学习内容基本信息 -->
      <div
        class="learn-task-module preview-learn-info"
        v-if="previewType === 1 || previewType === 2 || previewType === 5"
      >
        <p class="module-title">基本信息</p>
        <div class="module-content-box">
          <div class="form-item">
            <span class="form-label">主题：</span>
            <span class="form-content">{{infoObj.title}}</span>
          </div>
          <div class="form-item">
            <span class="form-label">章节目录：</span>
            <span class="form-content">{{infoObj | chapterFilter}}</span>
          </div>
          <div class="form-item">
            <span class="form-label">难易程度：</span>
            <span
              class="form-content"
            >{{infoObj.difficulty === 1 ? '简单' : (infoObj.difficulty ===2 ? '适中' : '困难')}}</span>
          </div>
          <div class="form-item">
            <span class="form-label">学习说明：</span>
            <span class="form-content">{{infoObj.description}}</span>
          </div>
          <div class="form-item">
            <span class="form-label">学习目标：</span>
            <span class="form-content">{{infoObj.target}}</span>
          </div>
          <div class="form-item">
            <span class="form-label">教师备注：</span>
            <span class="form-content">{{infoObj.remarks}}</span>
          </div>
          <div class="form-item">
            <span class="form-label">预计耗时：</span>
            <span class="form-content">{{infoObj.estimated}}分钟</span>
          </div>
        </div>
      </div>
      <!-- 学习资源列表 -->
      <div
        class="learn-task-module preview-learn-resource"
        v-if="(previewType === 1 || previewType === 2 || previewType === 5) && resourceList.length"
      >
        <p class="module-title">学习资源</p>
        <div class="module-content-box" id="previewLearnResource">
          <!-- 组件: 学习资源展示列表 -->
          <LearnResource
            :sort="false"
            :resource-list="resourceList"
            :addToFlexNum="addToFlexNum"
            :edit-power="false"
          />
        </div>
      </div>
      <!-- 习题列表 -->
      <div class="learn-task-module preview-learn-exercise" v-if="exerciseList.length">
        <p class="module-title">练习</p>
        <div class="module-content-box">
          <!-- 组件：习题列表 -->
          <ExerciseList
            :data-list="exerciseList"
            :editPower="false"
            :component-type="(previewType === 3 || previewType === 4 || previewType === 6) ? 5 : (previewType === 5 ? 3 : 2)"
          />
        </div>
      </div>
      <!-- 点评 -->
      <div
        class="learn-task-module preview-learn-review"
        v-if="previewType === 3 || previewType === 4 || previewType === 6"
      >
        <p class="module-title">点评</p>
        <template v-if="previewType === 3 || previewType === 4">
          <div class="review-div" :class="reviewError ? 'review-error' : ''">
            <el-input
              id="reviewTextarea"
              type="textarea"
              placeholder="请输入点评"
              v-model="learningData.review"
              :maxlength="200"
              @blur="_reviewBlur"
              @input="reviewError = false"
            ></el-input>
            <span class="remark-limit">{{learningData.review ? learningData.review.length: 0}}/200</span>
            <span v-if="reviewError" class="input-error">请填写点评内容</span>
          </div>
          <div class="review-template-list">
            <span
              class="review-template-item"
              v-for="(item, index) in reviewTemplateList"
              :key="index"
              @click="_addReviewTemplate(item)"
            >{{item}}</span>
          </div>
          <el-checkbox class="checkbox-excellent" v-model="learningData.isExcellent">优秀</el-checkbox>
        </template>
        <div v-else class="review-div">
          <el-input
            id="reviewTextarea"
            type="textarea"
            placeholder="请输入点评"
            v-model="learningData.review"
            readonly
          ></el-input>
        </div>
        <div v-if="previewType === 6 && learningData && learningData.reviewedTime" class="review-info">
          <span class="span-info-1">{{learningData.authorName}}老师</span>
          <span class="span-info-1">点评时间：</span>
          <span class="span-info-2">{{learningData.reviewedTime}}</span>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" v-if="previewType === 3 || previewType === 4">
      <el-button type="primary" size="small" @click="_dialogOk()">保存</el-button>
      <el-button size="small" @click="_dialogClose">返回</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  localStorageUtil,
  formatDateTime,
  formatTimeDifference
} from "utils/util";
import {
  reqGetLearningDetail,
  reqGetTaskAndLearningInfo,
  reqGetStudentAnswerInfo
} from "api/my-task";
import LearnResource from "components/learn-task/learn-resource";
import ExerciseList from "components/learn-task/exercise-list";
import PiePercentage from "components/learn-task/pie-percentage";
export default {
  name: "LearnTaskPreview",
  components: {
    LearnResource,
    ExerciseList,
    PiePercentage
  },
  props: {
    previewType: {
      /**
       * 1--教师端-学习内容预览
       * 2--教师端-任务学习内容预览
       * 3--教师端-查看学生结果
       * 4--教师端-查看学生结果-点评
       * 5--学生端-任务学习内容预览-无答案
       * 6--学生端-查看点评
       * **/
      type: [Number, String],
      default: 1
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [Number, String]
    },
    defaultData: {
      type: Object
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      learningTitle: "",
      learningData: null,
      infoObj: {},
      resourceList: [],
      exerciseList: [],
      addToFlexNum: 0,
      taskBaseInfo: {},
      reviewTemplateList: [
        "最近表现很棒！",
        "慢慢来，老师相信你能做的更好！",
        "这次练习完成的非常棒！",
        "告别粗心继续努力！",
        "老师期待看到你的进步！"
      ],
      reviewBlurTime: null,
      reviewBlurPosition: null,
      reviewError: false,
      loading: true
    };
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loading = true;
          if (this.previewType === 1) {
            // 1--教师端-学习内容预览
            this._getDetailInfo();
          } else if (this.previewType === 2 || this.previewType === 5) {
            // 2--教师端-任务学习内容预览
            this._getDetailInfo2();
          } else if (this.previewType === 3 || this.previewType === 4 || this.previewType === 6) {
            // 3--教师端-查看学生结果 4--教师端/学生端-查看学生结果-点评
            this._getDetailInfo3();
          }
        } else {
          if (this.reviewError) {
            this.reviewError = false;
          }
        }
      }
    }
  },
  filters: {
    chapterFilter(val) {
      let str = `${val.subjectName}/${val.editionName}/${val.volumeName}/${val.chapterOneTitle}`;
      if (val.chapterTwoTitle) {
        str += `/${val.chapterTwoTitle}`;
      } else if (val.chapterThreeTitle) {
        str += `/${val.chapterThreeTitle}`;
      }
      return str;
    }
  },
  computed: {
    dialogTitle() {
      if(this.previewType === 6) {
        return '查看点评：' + (this.title ? this.title : this.learningTitle);
      }
      return `“ ${this.title ? this.title : this.learningTitle} ” 预览`
    }
  },
  methods: {
    /**
     * 点评 使用模板
     * **/
    _addReviewTemplate(item) {
      let _now = new Date().getTime();
      if (
        this.reviewBlurTime !== null &&
        _now - this.reviewBlurTime < 500 &&
        this.reviewBlurPosition !== null
      ) {
        this.learningData.review =
          this.learningData.review.slice(0, this.reviewBlurPosition) +
          item +
          this.learningData.review.slice(this.reviewBlurPosition);
        this.setCaretPosition(
          $("#reviewTextarea"),
          this.reviewBlurPosition + item.length
        );
      } else {
        this.learningData.review += item;
        $("#reviewTextarea").focus();
      }
    },

    /**
     * 点评 失去焦点
     * **/
    _reviewBlur(e) {
      this.reviewBlurTime = new Date().getTime();
      this.reviewBlurPosition = e.target.selectionEnd;
      setTimeout(() => {
        this.reviewBlurPosition = null;
      }, 600);
    },

    /**
     * 点评 设置input光标位置
     * **/
    setCaretPosition(ctrl, pos) {
      this.$nextTick(() => {
        // Modern browsers
        if (ctrl[0].setSelectionRange) {
          ctrl.focus();
          ctrl[0].setSelectionRange(pos, pos);

          // IE8 and below
        } else if (ctrl[0].createTextRange) {
          var range = ctrl[0].createTextRange();
          range[0].collapse(true);
          range[0].moveEnd("character", pos);
          range[0].moveStart("character", pos);
          range[0].select();
        }
      });
    },

    /**
     * 保存
     * **/
    _dialogOk() {
      if (!this.learningData.review) {
        this.reviewError = true;
      } else {
        this.$emit("handleOk", "review", {
          review: this.learningData.review,
          isExcellent: this.learningData.isExcellent
        });
      }
    },

    /**
     * 关闭
     * **/
    _dialogClose() {
      this.$emit("handleOk", false);
    },

    /**
     * 获取详情 1--教师端-学习内容预览
     * **/
    _getDetailInfo() {
      this.addToFlexNum = 0;
      if (this.defaultData) {
        this.learningData = this.defaultData;
        let _basicInfo = Object.assign({}, this.defaultData.learningBaseInfo);
        this.infoObj = _basicInfo;
        this.learningTitle = this.infoObj.title
          ? this.infoObj.title
          : this.title;
        this.resourceList = this.defaultData.learningDetailList;
        this.exerciseList = this.defaultData.exercise.exerciseDetailList
          ? this.defaultData.exercise.exerciseDetailList
          : [];
        if (this.resourceList.length) {
          this._computeFlexNum();
        }
        this.loading = false;
        return;
      }
      let obj = {
        learningDataId: this.id
      };
      return reqGetLearningDetail(obj)
        .then(res => {
          this.loading = false;
          if (res.code === 0 && res.data) {
            let _res = res.data;
            this.learningData = res;
            let _basicInfo = Object.assign({}, _res.learningBaseInfo);
            this.infoObj = _basicInfo;
            this.learningTitle = this.infoObj.title
              ? this.infoObj.title
              : this.title;
            this.resourceList = _res.learningDetailList;
            this.exerciseList = _res.exercise.exerciseDetailList
              ? _res.exercise.exerciseDetailList
              : [];
            if (this.resourceList.length) {
              this._computeFlexNum();
            }
          } else {
            this.$message({
              type: "error",
              message: "获取详情失败",
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.loading = false;
          console.log("error", err);
        });
    },

    /**
     * 获取详情 2--教师端-任务学习内容预览
     * **/
    _getDetailInfo2() {
      this.addToFlexNum = 0;

      let obj = {
        learningTaskId: this.id
      };
      return reqGetTaskAndLearningInfo(obj)
        .then(res => {
          this.loading = false;
          if (res.code === 0 && res.data) {
            let _res = res.data;
            this.learningData = _res;
            let _basicInfo = Object.assign({}, _res.learningBaseInfo);
            this.infoObj = _basicInfo;
            this.learningTitle = this.infoObj.title
              ? this.infoObj.title
              : this.title;
            this.resourceList = _res.learningDetailList;
            this.exerciseList = _res.exercise.exerciseDetailList
              ? _res.exercise.exerciseDetailList
              : [];
            this.taskBaseInfo = _res.taskBaseInfo;
            this.taskBaseInfo.completedStudentCount = _res.taskBaseInfo
              .completedStudentCount
              ? _res.taskBaseInfo.completedStudentCount
              : 0;
            this.taskBaseInfo.totalStudentCount = _res.taskBaseInfo
              .totalStudentCount
              ? _res.taskBaseInfo.totalStudentCount
              : 0;
            this.taskBaseInfo.startTime = this.taskBaseInfo.startTime
              ? formatDateTime(
                  new Date(this.taskBaseInfo.startTime),
                  "yyyy-MM-dd HH:mm"
                )
              : "-";
            this.taskBaseInfo.dueTime = this.taskBaseInfo.dueTime
              ? formatDateTime(
                  new Date(this.taskBaseInfo.dueTime),
                  "yyyy-MM-dd HH:mm"
                )
              : "-";
            this.taskBaseInfo.options = [
              {
                value: this.taskBaseInfo.completedStudentCount,
                name: "正确",
                selected: true
              },
              {
                value:
                  this.taskBaseInfo.totalStudentCount -
                  this.taskBaseInfo.completedStudentCount,
                name: "错误"
              }
            ];
            if (this.resourceList.length) {
              this._computeFlexNum();
            }
          } else {
            this.$message({
              type: "error",
              message: "获取详情失败",
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.loading = false;
          console.log("error", err);
        });
    },

    /**
     * 获取详情 3--教师端-查看学生结果 4--教师端-查看学生结果-点评
     * **/
    _getDetailInfo3() {
      this.addToFlexNum = 0;

      let obj = {
        studentTaskId: this.id
      };
      return reqGetStudentAnswerInfo(obj)
        .then(res => {
          this.loading = false;
          if (res.code === 0 && res.data) {
            let _res = Object.assign({}, res.data);
            this.learningTitle = this.title;
            _res.objectiveCorrectedNum = _res.objectiveCorrectedNum ? _res.objectiveCorrectedNum : 0;
            _res.objectiveTotal = _res.objectiveTotal ? _res.objectiveTotal : 0;
             _res.estimated = formatTimeDifference( null,  null, _res.studentEstimated * 60 * 1000);
            _res.startTime = _res.startTime
              ? formatDateTime(new Date(_res.startTime), "yyyy-MM-dd HH:mm")
              : "-";
            _res.stopTime = _res.stopTime
              ? formatDateTime(new Date(_res.stopTime), "yyyy-MM-dd HH:mm")
              : "-";
            _res.reviewedTime = _res.reviewedTime
              ? formatDateTime(new Date(_res.reviewedTime), "yyyy-MM-dd HH:mm")
              : "";
            _res.options = [
              {
                value: _res.objectiveCorrectedNum,
                name: "正确",
                selected: true
              },
              {
                value: _res.objectiveTotal - _res.objectiveCorrectedNum,
                name: "错误"
              }
            ];
            if(_res.objectiveCorrectedNum === _res.objectiveTotal && _res.objectiveTotal === 0) {
              _res.options[1].value = 1;
            }
            _res.review = _res.review ? _res.review : "";
            _res.isExcellent = _res.isExcellent ? _res.isExcellent : false;
            this.learningData = Object.assign({}, _res);
            // this.exerciseList = _res.exerciseDetailList;
            this.exerciseList = _res.exerciseDetailList
              ? _res.exerciseDetailList
              : [];
            if (this.previewType === 4 || this.previewType === 6) {
              this.$nextTick(() => {
                document
                  .getElementById("reviewTextarea")
                  .scrollIntoView({ behavior: "smooth" });
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "获取详情失败",
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.loading = false;
          console.log("error", err);
        });
    },
    /**
     * 计算flex布局要填充几个
     * **/
    _computeFlexNum() {
      if (!this.resourceList.length) {
        this.addToFlexNum = 0;
        return;
      }
      this.addToFlexNum = 0;
      this.$nextTick(() => {
        let ele = $("#previewLearnResource");
        let _w1 = ele.width();
        let ele1 = $("#previewLearnResource .item-wrapper").eq(0);
        let _w2 = ele1.outerWidth() + parseInt(ele1.css("marginRight"));
        let _num1 = Math.floor(_w1 / _w2); // 一行能放下多少
        let _num2 = Math.ceil(this.resourceList.length / _num1); // 最多能放多行
        if (this.resourceList.length % _num1) {
          if (_num1 * _num2 - this.resourceList.length > 0) {
            this.addToFlexNum = _num1 * _num2 - this.resourceList.length;
          }
        }
      });
    }
  },
  created() {}
};
</script>
<style lang="less">
.learn-task-preview-component {
  .self-el-dialog {
    height: 95vh !important;
    margin-top: 5vh !important;
    margin-bottom: 0;
    border-radius: 8px 8px 0 0;

    .el-dialog__body {
      height: calc(100% - 44px);
      padding: 0 0 15px 30px !important;
      overflow: hidden;
      position: relative;
      .iconyouxiu {
        font-size: 36px;
        color: #FFC600;
        position: absolute;
        top: 18px;
        right: 24px;
      }

      .learn-task-preview {
        margin-top: 80px;
        height: calc(100% - 80px);
        overflow: auto;
        padding-right: 20px;
        .learn-task-module {
          font-size: 14px;
          .module-title {
            font-size: 18px;
            font-weight: bold;
            color: #595959;
            position: relative;
            padding-bottom: 20px;
            line-height: 1;
            display: inline-block;
            z-index: 1;

            &:before {
              content: "";
              display: inline-block;
              position: absolute;
              left: 0;
              bottom: 11px;
              width: 110%;
              height: 14px;
              background: #C7E9E2;
              z-index: -1;

            }
          }

          .module-content-box {
            width: 100%;

            .form-item {
              width: 100%;
              padding-bottom: 20px;

              .form-label {
                display: inline-block;
                width: 100px;
                text-align: right;
                color: #595959;
                font-weight: bold;
                line-height: 22px;
              }

              .form-content {
                display: inline-block;
                width: calc(100% - 120px);
                padding-left: 12px;
                padding-right: 20px;
                color: #666666;
                vertical-align: top;
                line-height: 22px;
              }
            }
          }
        }

        

        .preview-learn-resource {
          .module-title {
            padding-bottom: 10px;
            &:before {
              bottom: 1px;
            }
          }

          .edit-resource-list {
            padding-left: 30px;

            .item-wrapper {
              margin-right: 10px;
              width: 254px;
              height: 235px;

              .item-box {

                .top-box {
                  width: 100%;
                  height: 144px;
                  text-align: center;

                  .item-title {
                    height: 30px;
                    line-height: 30px;
                    padding: 0 6px;
                    font-size: 14px;
                  }
                }

                .center-box {
                  width: 100%;
                  margin-top: 8px;
                  margin-bottom: 10px;
                  padding: 0 12px;

                  .iconfont {
                    font-size: 14px;
                  }
                }

                .bottom-box {
                  padding: 0 12px;
                  .resource-description {
                    height: 20px !important;
                    text-overflow: ellipsis !important;
                    overflow: hidden !important;
                    white-space: nowrap !important;
                    display: block !important;
                    -webkit-line-clamp: 1 !important;
                  }

                  .el-input {
                    .el-input__inner {
                      height: 26px;
                      border: 1px solid #d9d9d9 !important;
                    }
                  }

                  .input-readonly.el-input {
                    .el-input__inner {
                      background: #fafafa;
                      border-color: #fafafa !important;
                      color: #7b7979;
                    }
                  }
                }
              }
            }
          }
        }

        .preview-learn-exercise {
          .module-content-box {
            padding-left: 30px;
            padding-right: 30px;

            .item-exercise {
              width: 100%;
            }
          }
        }

        .preview-learn-review {
          margin-top: 22px;
          padding-bottom: 20px;
          .review-div {
            width: 100%;
            padding: 0 30px;
            height: 110px;
            position: relative;

            .el-textarea__inner {
              resize: none;
              width: 100%;
              height: 110px;
              border: 1px solid #d9d9d9;
              border-radius: 4px;
            }

            .remark-limit {
              position: absolute;
              right: 38px;
              bottom: 4px;
              color: #999;
            }

            .input-error {
              display: none;
              height: 0;
              color: #f56c6c;
              font-size: 12px;
              line-height: 1;
              padding-top: 8px;
              // position: absolute;
              // left: 64px;
              // top: 68px;
              animation: fadein 0.5s;
            }

            &.review-error {
              .el-textarea__inner {
                border: 1px solid #f56c6c;
              }

              .input-error {
                display: inline-block;
              }
            }
          }

          .review-template-list {
            width: 100%;
            padding: 30px 30px 10px 30px;

            .review-template-item {
              display: inline-block;
              color: #6b6b6b;
              background: #ededed;
              padding: 8px 12px;
              margin-right: 15px;
              border-radius: 4px;
              cursor: pointer;

              &:hover {
                background: #cff2e4;
              }
            }
          }

          .checkbox-excellent {
            padding-left: 30px;
            padding-top: 10px;
          }
          .review-info {
            padding: 20px 30px;
            font-size: 14px;
            .span-info-1 {
              color: #919191;
              &+.span-info-1 {
                padding-left: 10px;
              }
            }
            .span-info-2 {
              color: #515151;
            }
          }
        }
      }

      .learn-task-preview-laoding {
        width: 100%;
        height: 100%;
      }
      .preview-learn-student-info {
        position: absolute;
        top: 15px;
        left: 24px;
        height: 40px;
        line-height: 40px;
        background: #FAFAFA;  
        border-radius: 8px;
        padding: 0 12px;
        

        .span-icon {
          padding-right: 30px;
          color: #515151;
          font-size: 14px;
          vertical-align: middle;
          display: inline-block;

          .iconfont {
            padding-right: 6px;

            &:before {
            }
          }

          &.span3 {
            max-width: 470px;
          }

          &.span1 .iconfont {
            color: #7BCBFF;
          }

          &.span2 .iconfont {
            color: #55DCBD;
          }

          &.span3 .iconfont {
            color: #80B6FF;
          }

          &.span4 .iconfont {
            color: #ffb173;
          }

          &.span5 .iconfont {
            &.iconhaoshi {
              color: #91A3FF;
            }

            &.iconjinhangzhong {
              color: #91A3FF;
            }
            &.iconweikaishi1 {
              color: #CDCDCD;
            }
            &.iconguoqi {
              color: #FF9191;
            }
          }

          &.span6 .iconfont {
            color: #007a49;
          }

          &.task-progress {
            display: inline-block;
            height: 100%;
            vertical-align: middle;

            .el-progress {
              vertical-align: middle;
              padding-right: 8px;
              margin-top: -1px;
            }
          }

          &.pie-ercentage {
            .pieEcharts {
              vertical-align: top;
              margin-right: 8px;
              margin-top: 9px;
            }
          }
        }
      }
    }

    .el-dialog__footer {
    }
  }

  &.show-footer {
    .self-el-dialog {
      .el-dialog__body {
        height: calc(100% - 100px);
      }

      .el-dialog__footer {
        padding: 10px 20px;
      }
    }
  }
}

@keyframes fadein {
  0% {
    height: 0;
    opacity: 0.3;
  }

  100% {
    height: 16px;
    opacity: 1;
  }
}

@media (max-width: 1366px) {
  .learn-task-preview-component .el-dialog.self-el-dialog {
    width: 1200px !important;
  }
}
</style>